import { Component, HostListener, Inject, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UTILS } from 'src/app/entities/Utils';
import { Address, GenericResponse, Indirizzo, PA } from 'src/app/entities/various';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { ModalServiceService } from 'src/app/services/modal-service/modal-service.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { RubricaComponent } from '../rubrica.component';
import { Address as AddressValidator } from 'src/app/entities/Address';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-rubrica-editor',
  templateUrl: './rubrica-editor.component.html',
  styleUrls: ['./rubrica-editor.component.css']
})
export class RubricaEditorComponent implements OnInit {

  @Input() addressId:string | number| undefined;
  @Input() userId: number| undefined;
  address: Address | undefined;
  innerWidth: number | undefined;
  indirizzo: Indirizzo | undefined;
  
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  
  params : HttpParams;
  elencoPA : any;
  elencoSfe: any;
  search: boolean = false;
  section : string = 'sede';
  public addressHelper=new AddressValidator();
  easyMode : boolean =true;

  constructor(private configService : ConfigurationService, private translate : TranslateService,
    private modalService : ModalServiceService, @Inject(RubricaComponent) private rubrica: RubricaComponent, private toast : ToastService) {
    this.innerWidth = window.innerWidth;
    this.params = new HttpParams();
   }

  async ngOnInit() {
    if(this.addressId != 'new') {
      
      await this.configService.getAddressById(this.userId!, this.addressId!).then(
        (res) => {
          this.indirizzo = res.data;
        }
      );
      
    } else {
      this.indirizzo = {
        id: 0,
        user_id: this.userId!,
        denominazione: '',
        id_paese: '',
        partita_iva: '',
        codice_fiscale: '',
        indirizzo: '',
        civico: '',
        comune: '',
        provincia: '',
        nazione: '',
        cap: '',
        codice_destinatario: '',
        email: '',
        persona_fisica: 'f',
        nome: '',
        cognome: '',
        is_pa: 'f',
        pec: ''
      };
    }
  }

 

  async searchPA(val : string) {
    this.elencoPA = (await this.configService.getElencoPA(this.userId!, val)).data;
    this.search = true;

  }

  async cercaPA() {
    this.search = true;
    this.params= this.params.append('searchFilter', '{\"DESCR\":\"' + this.indirizzo?.denominazione +'\"}');

    await this.configService.cercaPA(this.params).then(
      (res) => {
        this.elencoPA = res.data;
      }
    );

  }

  async selezionaRisultato(risultato: any) {
    
    this.params = this.params.append('searchFilter', '{\"COD_AMM\":\"' + risultato.cod_amm +'\"}');

    await this.configService.cercaPA(this.params).then(
      async (res) => {
        this.elencoPA = null;
        this.indirizzo!.denominazione = res.data.des_amm;
        this.indirizzo!.email = res.data.mail1;
        this.indirizzo!.codice_fiscale = res.data.cf;
        this.indirizzo!.indirizzo = res.data.indirizzo;
        this.indirizzo!.nazione = 'IT';
        this.indirizzo!.comune = res.data.comune;
        this.indirizzo!.provincia = res.data.provincia;
        this.indirizzo!.cap = res.data.cap;
        this.indirizzo!.is_pa = 't';

        this.params = this.params.delete('searchFilter');
        this.params= this.params.append('searchFilter', '{\"CF\":\"' + risultato.cod_amm +'\"}');
        await this.configService.cercaPA(this.params).then(
          (sfe) => {
            this.elencoSfe = sfe.data;
          }
        );
      }
    );
    
  }

  async selezionaRisultatoSfe(risultato: any) {
    this.elencoSfe = null;
    this.indirizzo!.codice_destinatario = risultato.cod_uni_ou;
  }

  public sostituiscicarattere(denominazione: string) {
    const chars: any = {
      'à': 'a',
      'è': 'e',
      'é': 'e',
      'ì': 'i',
      'ò': 'o',
      'ù': 'u'
    }
    return (denominazione).replace(/[àèéìòù]/g, m => chars[m]);
  }

  async selectPA(pa : PA){
    this.address = await (await this.configService.getNewAddress()).data;
    if (this.address) {
      this.address.id= this.addressId!;
      this.address.denominazione = pa.des_ou;
      this.address.data!.DatiAnagrafici.Anagrafica.Denominazione = pa.des_ou;
      this.address.codice_univoco_pa= pa.cod_uni_ou;
      this.address.data!.DatiAnagrafici.Anagrafica.CodiceUnivoco = pa.cod_uni_ou;
      this.address.codice_fiscale=pa.cf;
      this.address.data!.DatiAnagrafici.CodiceFiscale = pa.cf;
      this.address.data!.Sede.Indirizzo = pa.indirizzo;
      this.address.data!.Sede.Comune = pa.comune;
      this.address.data!.Sede.CAP = pa.cap;
      this.address.data!.Sede.Provincia = pa.provincia;
      this.address!.data!.StabileOrganizzazione = [{
        CAP : '',
        Citta : '',
        Comune : '',
        Indirizzo : '',
        NumeroCivico : '',
        Provincia : ''
      }];
    }
    
        
  }

  goTo(section : string) {
    this.section = section;
  }

  setPersonaFisica() {
    if(this.indirizzo!.persona_fisica == 't') {
      this.indirizzo!.persona_fisica = 'f';
    } else {
      this.indirizzo!.persona_fisica = 't';
    }
     
  }

  async save() {
    if(!this.validaForm())
          return;

    let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.save");
    let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.save");
    let check = await this.modalService.openConfirm(label, message);
    let response : GenericResponse;
    if(check) {
      if(this.addressId == 'new') {
        response = await this.configService.salvaIndirizzo(this.userId!, this.indirizzo);
      } else {
        response = await this.configService.saveAddress(this.userId!, this.indirizzo);
      }
      
      
      if(response && response.success) {
        if(this.addressId == 'new') {
          if(response.error!=null)
                this.toast.openToastWithConfig(true, 5000,response.error, "error");
          else
                this.toast.openToastWithConfig(true, 5000, await new UTILS().getTranslateTitle(this.translate,"toast.save.success"), "success")      
        }
        else   this.toast.openToastWithConfig(true, 5000, await new UTILS().getTranslateTitle(this.translate,"toast.save.success"), "success")
        
        this.refresh();

      } else {
        this.toast.openToast(response.msg, "warning")
        
      }
      

    }
  }


  validaForm(){
    if (this.indirizzo?.denominazione.length == 0 && (this.indirizzo?.nome.length == 0 || this.indirizzo?.cognome.length == 0)) {
      this.toast.openToastWithConfig(true, 5000, "Inserisci la denominazione o la ragione sociale", "warning");
      return false;
    }
    if (this.indirizzo?.codice_destinatario.length == 0) {
      this.toast.openToastWithConfig(true, 5000, "Inserisci il codice destinatario", "warning");
      return false;
    }
    if (this.indirizzo?.partita_iva.length == 0 && this.indirizzo.codice_fiscale.length == 0) {
      this.toast.openToastWithConfig(true, 5000, "Inserisci il codice fiscale o la partita IVA", "warning");
      return false;
    }
    if (this.indirizzo!.partita_iva.length > 0 && this.indirizzo?.id_paese.length == 0) {
      this.toast.openToastWithConfig(true, 5000, "Inserisci il campo nazione della partita IVA", "warning");
      return false;
    }
    if (this.indirizzo?.indirizzo.length == 0) {
      this.toast.openToastWithConfig(true, 5000, "Inserisci l'indirizzo", "warning");
      return false;
    }
    if (this.indirizzo?.nazione.length == 0) {
      this.toast.openToastWithConfig(true, 5000, "Inserisci la nazione dell'indirizzo", "warning");
      return false;
    }
    if (this.indirizzo?.provincia.length == 0) {
      this.toast.openToastWithConfig(true, 5000, "Inserisci la provincia", "warning");
      return false;
    }
    if (this.indirizzo?.comune.length == 0) {
      this.toast.openToastWithConfig(true, 5000, "Inserisci il comune", "warning");
      return false;
    }
    if (this.indirizzo?.cap.length == 0) {
      this.toast.openToastWithConfig(true, 5000, "Inserisci il CAP", "warning");
      return false;
    }

    return true;
     
  }


 


  changeMode(){
    this.easyMode=!this.easyMode;
    if(this.easyMode==true){
      this.section='sede';
      this.address!.data!.DatiAnagrafici.Anagrafica.CodEORI="";
      this.address!.data!.StabileOrganizzazione[0].Indirizzo="";
      this.address!.data!.StabileOrganizzazione[0].NumeroCivico="";
      this.address!.data!.StabileOrganizzazione[0].Comune="";
      this.address!.data!.StabileOrganizzazione[0].CAP="";
      this.address!.data!.StabileOrganizzazione[0].Provincia="";
      this.address!.data!.RappresentanteFiscale.DatiAnagrafici.Anagrafica.PersonaFisica=0;
      this.address!.data!.RappresentanteFiscale.DatiAnagrafici.Anagrafica.Titolo='';
      this.address!.data!.RappresentanteFiscale.DatiAnagrafici.Anagrafica.Nome='';
      this.address!.data!.RappresentanteFiscale.DatiAnagrafici.Anagrafica.Cognome='';
      this.address!.data!.RappresentanteFiscale.DatiAnagrafici.Anagrafica.Denominazione='';
      this.address!.data!.RappresentanteFiscale.DatiAnagrafici.IdFiscaleIVA.IdPaese='';
      this.address!.data!.RappresentanteFiscale.DatiAnagrafici.IdFiscaleIVA.IdCodice='';
      this.address!.data!.RappresentanteFiscale.DatiAnagrafici.Anagrafica.CodEORI='';
    }
  }


  clearAnagraficaFields(){
    if(this.address!.data!.DatiAnagrafici.Anagrafica.PersonaFisica==1){
      this.address!.data!.DatiAnagrafici.Anagrafica.Denominazione="";
    }else{
      this.address!.data!.DatiAnagrafici.Anagrafica.Nome="";
      this.address!.data!.DatiAnagrafici.Anagrafica.Cognome="";
      this.address!.data!.DatiAnagrafici.Anagrafica.Titolo="";
    }
  }


  async delete() {
    
    let label : string = await new UTILS().getTranslateTitle(this.translate,"modal.labels.delete");
    let message : string = await new UTILS().getTranslateTitle(this.translate,"modal.messages.delete");
    let check = await this.modalService.openConfirm(label, message);
    let response : GenericResponse;
    if(check) {
      response = await this.configService.deleteAddress(this.userId!, this.indirizzo!.id);
      if(response && response.success) {
        this.toast.openToastWithConfig(true, 5000, await new UTILS().getTranslateTitle(this.translate,"toast.delete.success"), "success")
        
        this.refresh();

      } else {
        this.toast.openToast(response.msg, "warning")
        
      }

    }
  }

  refresh() {
    this.rubrica.editing= false;
  }
}
